module.exports = __webpack_public_path__ + "static/media/icon_select_btn.9c60a845.svg";